// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1NTTD","assignButton":"CreateEditEquipmentSchedule_assignButton__1P0Ac"};